export default function initializeHeader() {
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    const stickyToHeaderElements = document.querySelectorAll('.sticky-to-header');
    stickyToHeaderElements.forEach(element => {
        element.style.top = header.offsetHeight + 'px';
    });

    window.addEventListener('scroll', () => {
        if (document.body.dataset.scroll_script === 'true') {
            document.body.dataset.scroll_script = 'false';
            return;
        }

        let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (currentScrollTop > lastScrollTop && currentScrollTop > 300) {
            header.classList.add('header--hidden');
            // jeśli .sub-menu jest otwarte, to je zamykamy
            header.querySelectorAll('.menu__item--open').forEach(item => {
                item.classList.remove('menu__item--open');
            });

            stickyToHeaderElements.forEach(element => {
                element.style.top = 0;
                element.classList.remove('sticky-to-header--header-visible');
            });
        } else {
            header.classList.remove('header--hidden');
            stickyToHeaderElements.forEach(element => {
                element.style.top = header.offsetHeight + 'px';
                element.classList.add('sticky-to-header--header-visible');
            });
        }

        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    }, false);

    // dodaj klasę .menu__item--open dla elementu .menu__item, który zawiera element .sub-menu i myszka jest nad tym elementem lub jednym z jego elementów potomnych
    document.querySelectorAll('.menu__item.menu-item-has-children').forEach(item => {
        item.addEventListener('mouseenter', () => {
            item.classList.add('menu__item--open');
        });

        item.addEventListener('mouseleave', () => {
            item.classList.remove('menu__item--open');
        });
    });
}